import { createAsyncThunk } from '@reduxjs/toolkit'
import { Claim, UpdateClaimThunkParams } from '@dataTypes/claimManagement.types'
import claimsData from '@assets/mockdata/Claims/claimsData'

let mockClaims: Claim[] = [...claimsData]

export const fetchAllClaims = createAsyncThunk<Claim[], void>(
  'api/claims/fetchAllClaims',
  async (_, { rejectWithValue }) => {
    try {
      return mockClaims
    } catch (error) {
      return rejectWithValue('Failed to fetch claims')
    }
  },
)

export const addClaim = createAsyncThunk<Claim, Claim>(
  'api/claims/addClaim',
  async (newClaim, { rejectWithValue }) => {
    try {
      mockClaims = [...mockClaims, newClaim]
      return newClaim
    } catch (error) {
      return rejectWithValue('Failed to add claim')
    }
  },
)

export const updateClaim = createAsyncThunk<Claim, UpdateClaimThunkParams>(
  'api/claims/updateClaim',
  async ({ id, body }: UpdateClaimThunkParams, { rejectWithValue }) => {
    try {
      const index = mockClaims.findIndex((claim) => claim.id === id)
      if (index === -1) throw new Error('Claim not found')

      mockClaims[index] = { ...body, id }
      return mockClaims[index]
    } catch (error) {
      return rejectWithValue('Failed to update claim')
    }
  },
)

export const removeClaim = createAsyncThunk<string, string>(
  'api/claims/removeClaim',
  async (id, { rejectWithValue }) => {
    try {
      mockClaims = mockClaims.filter((claim) => claim.id !== id)
      return id
    } catch (error) {
      return rejectWithValue('Failed to remove claim')
    }
  },
)
